import React, { Component } from "react";
import { getUsers, deleteUser } from "../../services/userService";
import Pagination from "../common/pagination";
import { paginate } from "../../utils/paginate";
import SearchTextBox from "../common/searchTextBox";
import UsersTable from "./usersTable";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import _ from "lodash";
import TableTitle from "../common/tableTitle";
import { Table, Confirm } from "semantic-ui-react";
import TopStatus from "../common/topStatus";
import ModuleFiltersSimple from "../common/moduleFiltersSimple";
import NotFound from "../common/notfound";

class Users extends Component {
  state = {
    open: false,
    cashier: "",
    cashiers: [],
    pageSize: 10,
    currentPage: 1,
    keyFieldValue: "",
    sortColumn: { path: "title", order: "asc" },
    noRecordFound: "",
  };

  async componentDidMount() {
    document.body.style.backgroundImage = "none";
    this.setState({ blocking: true });
    const { data: cashiers } = await getUsers("cashier");
    this.setState({ cashiers, blocking: false });
  }

  handleDelete = (cashier) => {
    this.setState({ open: true, cashier });
  };

  doDelete = async () => {
    const cashier = this.state.cashier;
    const originalCashiers = this.state.cashiers;
    const cashiers = originalCashiers.filter((o) => o.id !== cashier.id);
    this.setState({ cashiers, open: false });

    try {
      await deleteUser(cashier.id);

      toast.success("User has been deleted successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        toast.success("This user has already been deleted.");
      }

      this.setState({ cashiers: originalCashiers });
    }
  };

  handleUpdate = (cashier) => {
    return this.props.history.replace("/users/" + cashier.id + "/edit");
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  handleSearching = (keyword) => {
    this.setState({ keyFieldValue: keyword, currentPage: 1 });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      cashiers: allCashiers,
      keyFieldValue,
      sortColumn,
    } = this.state;

    const filtered = keyFieldValue
      ? allCashiers.filter(
          (m) => m.name.toUpperCase().indexOf(keyFieldValue.toUpperCase()) > -1
        )
      : allCashiers;

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const cashiers = paginate(sorted, currentPage, pageSize);
    return { totalCount: filtered.length, data: cashiers };
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/users.png";
    const { pageSize, currentPage, sortColumn } = this.state;
    const { totalCount, data: cashiers } = this.getPagedData();
    const { length: count } = cashiers.length;

    if (count === 0 && this.state.blocking === false) {
      return (
        <NotFound
          title="Users"
          linkTitle="User"
          link="/users/new"
          button={true}
        />
      );
    }

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.open}
          header="Confirmation"
          content="Are you sure, you want to delete the user?"
          onCancel={this.handleCancel}
          onConfirm={this.doDelete}
          size="mini"
        />

        <h1 className="container__heading">Users</h1>

        <article className="grid filters-simple">
          <ModuleFiltersSimple
            onSearchButtonClick={this.handleSearching}
            addLink="/users/new"
            addTitle="User"
          />
        </article>

        <TopStatus count={totalCount} module="Users" />

        <UsersTable
          cashiers={cashiers}
          sortColumn={sortColumn}
          onDelete={this.handleDelete}
          onUpdate={this.handleUpdate}
          onSort={this.handleSort}
        />
        <Pagination
          itemsCount={totalCount}
          pageSize={pageSize}
          onPageChange={this.handlePageChange}
          currentPage={currentPage}
        />
      </BlockUi>
    );
  }
}

export default Users;
